import { render } from "./PricingAndMarginTopSection.vue?vue&type=template&id=8dfa352a&scoped=true"
import script from "./PricingAndMarginTopSection.vue?vue&type=script&lang=js"
export * from "./PricingAndMarginTopSection.vue?vue&type=script&lang=js"

import "./PricingAndMarginTopSection.vue?vue&type=style&index=0&id=8dfa352a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dfa352a"]])

export default __exports__